import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCompanyDetails, getCompanyDetails, setAudience } from '../../../redux/hubSlice';
import EditProfileModal from './EditProfileModal';
import userAvatar from '../../assets/images/user-avatar.png';

const HubLayout = ({ children, headerStyle = {}, hideHeader = false, default_host, logo_path, props }) => {
  const dispatch = useDispatch();
  const audience = props?.audience || props;
  const firstName = audience?.first_name?.trim() || '';
  const lastName = audience?.last_name?.trim() || '';
  const emailOrName = firstName ? `${firstName} ${lastName}`.trim() : audience?.email;
  const profileImg = audience?.avatar_url || userAvatar;
  const shouldPromptProfile = Boolean(audience?.email) && (!firstName || !lastName);

  useEffect(() => {
    dispatch(fetchCompanyDetails());
    audience && dispatch(setAudience({ ...audience }));
  }, []);

  useEffect(() => {
    if (!shouldPromptProfile || !audience?.id) return;

    const promptKey = `un-basic-profile-prompted-${audience.id}`;
    if (window.sessionStorage.getItem(promptKey)) return;

    window.sessionStorage.setItem(promptKey, 'true');
    window.setTimeout(() => {
      window.$?.('#editProfileModal')?.modal?.('show');
    }, 0);
  }, [audience?.id, shouldPromptProfile]);

  const company = useSelector((state) => getCompanyDetails(state));

  const navigateTo = (path) => {
    window.location.href = `/${company?.slug}${path}`;
  };

  const layoutStyle = hideHeader
    ? { background: 'none', minHeight: '100vh', height: 'auto' }
    : { background: 'none' };

  return (
    <>
      <div className="un-hub" style={layoutStyle}>
        {!hideHeader &&
          <div className="un-hub__header" style={headerStyle}>
            {default_host}
            {(logo_path || company.logo_url) && <img src={logo_path || company.logo_url} onClick={() => navigateTo('')} alt="Company Logo" />}
            {!default_host && <>
              {audience.email ?
                <>
                  <div className='signin-detail'>
                    <img src={profileImg} alt="User Avatar" />
                    <button onClick={() => $('#editProfileModal').modal('show')}>{emailOrName} |</button>
                    <button className="un-btn un-btn--primary" style={{ paddingLeft: 5 }} onClick={() => navigateTo('/sign_out')}>
                      Sign out
                    </button>
                  </div>
                </>
                :
                <button className="un-btn un-btn--primary signin-btn-class" onClick={() => navigateTo('/passwordless_sign_in')}>
                  Sign in as a Learner
                </button>
              }            
            </>}
          </div>
        }
        {children}
      </div >
      <EditProfileModal audience={audience} modalClose={() => $('#editProfileModal').modal('hide')} />
    </>
  );
};

export default HubLayout;
